import actions from './actions';
import ordersService from '../../services/ordersService';

const setDlistLoading = actions.setDlistLoading;
const setDlistData = actions.setDlistData;
const setDlistError = actions.setDlistError;
const clearDlistData = actions.clearDlistData;

/**
 * Fetch DLIST data by requestor code and date
 * @param {string} requestorCode - The requestor code
 * @param {string} date - The date in YYYY-MM-DD format
 * @returns {Function} - Redux thunk
 */
const fetchDlistData = (requestorCode, date) => async (dispatch) => {
  dispatch(setDlistLoading(true));
  dispatch(setDlistError(null));

  try {
    // Call the backend API to get DLIST data
    const raw = await ordersService.EPN.getDlist({ requestorCode, date });

    // Normalize API payload into the shape expected by the DLIST UI
    const header = raw?.dListHeader || raw;
    const driverRecords = raw?.driverRecordsList || raw?.drivers || [];
    const toYYYYMMDD = (d) => {
      const dt = new Date(d);
      return Number.isNaN(dt.getTime()) ? '' : dt.toISOString().slice(0, 10).replace(/-/g, '');
    };

    const drivers = driverRecords.map((r) => ({
      Name: r.Name ?? r.name ?? '',
      LicenseNumber: r.LicenseNumber ?? r.licenseNumber ?? '',
      AddDate: r.AddDate ?? r.addDate ?? '',
      ConditionCode: r.ConditionCode ?? r.condCode ?? '',
      Comments: r.Comments ?? r.comments ?? '',
      NoticeDateValues:
        r.NoticeDateValues ??
        (Array.isArray(r.noticeDates) ? r.noticeDates.map(toYYYYMMDD).filter(Boolean).join('|') : '')
    }));

    dispatch(setDlistData({
      ...header,
      driverCount: header.driverCount ?? header.totalRecords,
      drivers
    }));
  } catch (error) {
    console.error('Error fetching DLIST data:', error);
    
    // Set empty data structure so tables can still render with "No records available"
    dispatch(setDlistData({ drivers: [] }));
  } finally {
    dispatch(setDlistLoading(false));
  }
};

/**
 * Clear DLIST data from state
 * @returns {Function} - Redux thunk
 */
const clearDlist = () => (dispatch) => {
  dispatch(clearDlistData());
};

export default {
  fetchDlistData,
  clearDlist,
  setDlistLoading,
  setDlistData,
  setDlistError,
  clearDlistData
};
